/**
 * Header
 */

import Component from '../../js/core/component.js';
import Drawer from '../drawer/c-drawer.js';
import icon from '../icon/c-icon.js';
import CollapsableNavigation from '../navigation/collapsable-navigation/c-collapsable-navigation.js';
import breakpoint from '../../js/utilities/breakpoint/u-breakpoint.js';
import PopOut from '../pop-out/c-pop-out.js';

/* Polyfills */
import '../../js/vendor/polyfills/polyfill-nodelist-foreach.js';
import '../../js/vendor/polyfills/polyfill-prepend.js';
import '../../js/vendor/polyfills/polyfill-remove.js';

class Header extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			classes: {
				drawerToggler: 'c-header__drawer-toggler',
				anchor: 'c-header__link'
			}
		};
	}

	/**
	 * Initialize Header
	 */
	_init () {
		this.element = this.settings.element;

		if(this.element.classList.contains('c-header--stripped-down')) {
			return;
		}

		this.ceiling = this.element.querySelector('.c-header__ceiling');
		this.inner = this.element.querySelector('.c-header__inner');
		this.floor = this.element.querySelector('.c-header__floor');
		this.floorInner = this.floor.querySelector('.c-header__floor-inner');
		this.logotype = this.inner.querySelector('.c-header__logo');
		this.additional = this.element.querySelector('.c-additional-navigation');
		this.test = this.element.querySelectorAll('.c-additional-navigation__item:not(.c-additional-navigation__item--translate)');
		this.loggedIn = this.element.hasAttribute('data-logged-in')
		this.loginButtonAnchor = this.element.getAttribute('data-login-button-anchor')
		this.homePage = this.element.hasAttribute('data-home')

		this.navigations = {
			entry: this.element.querySelector('.c-entry-navigation'),
			supplemental: this.element.querySelector('.c-supplemental-navigation'),
			main: this.element.querySelector('.c-main-navigation'),
			searchForm: this.element.querySelector('.c-search-form')
		};

		this._createTranslateToggler();

		breakpoint('screen and (max-width: 767px)', {
			enter: () => {
				this.initNarrow();
			},
			exit: () => {
				this.destroyNarrow();
			}
		});

	}

	_createMenuDrawer () {
		this.menuDrawer = new Drawer({
			classes: {
				bodyWhenOpen: 'c-drawer-is-open-fixed-menu'
			},
			on: {
				toggle: (drawer) => {
					this._updateDrawerToggler(drawer, this.menuDrawerToggler, this.menuDrawerTogglerText, '/gui/images/icons/menu.svg', 'Meny');
				}
			}
		});

		if(this.ceiling) {
			this.menuDrawer.content.appendChild(this.ceiling);
		}
		this.menuDrawer.content.appendChild(this.inner);
		this.menuDrawer.content.appendChild(this.floor);

		if(this.additional) {
			this.translateToggler.destroy();
			this.translateClone = this.additional;

			let additionalListItem = this.translateClone.querySelectorAll('.c-additional-navigation__item:not(.c-additional-navigation__item--translate)');
			if(additionalListItem) {
				additionalListItem.forEach((element) => {
					element.remove();
				});
			}

			this.translateClone.querySelector('.c-additional-navigation__translate').classList.remove('c-pop-out');
			this.menuDrawer.content.appendChild(this.translateClone);
		}

		this.element.appendChild(this.logotype);
		if(this.inner.children.length === 0) {
			this.inner.remove();
		}

		this._addNarrowClasses();
	}

	_createSearchDrawer () {
		if(this.navigations.searchForm) {
			this.searchDrawer = new Drawer({
				on: {
					toggle: (drawer) => {
						this._updateDrawerToggler(drawer, this.searchDrawerToggler, this.searchDrawerTogglerText, '/gui/images/icons/magnifying-glass.svg', 'Sök');
					}
				}
			});

			this.searchDrawer.content.appendChild(this.navigations.searchForm);
		}
	}
	
	_createLoginbutton() {
		this.loginToggler = document.createElement('button');
		this.loginToggler.classList.add(this.settings.classes.drawerToggler);
		this.loginTogglerText = document.createElement('span');
		if(!this.loggedIn) {
			this.loginTogglerText.innerHTML = 'Logga in';
			this.loginTogglerIcon = icon({
				icon: '/gui/images/icons/person.svg',
				size: 's',
				extraClass: 'c-header__drawer-toggler-icon'
			});
		} else {
			this.loginTogglerText.innerHTML = 'Mina sidor';
			this.loginTogglerIcon = icon({
				icon: '/gui/images/icons/person.svg',
				size: 's',
				extraClass: 'c-header__drawer-toggler-icon--green'
			});
		}
		this.loginAnchor = document.createElement('a')
		this.loginAnchor.appendChild(this.loginTogglerIcon);
		this.loginAnchor.setAttribute('href', this.loginButtonAnchor)
		this.loginAnchor.classList.add(this.settings.classes.anchor);
		this.loginToggler.appendChild(this.loginAnchor);

		
		this.loginAnchor.appendChild(this.loginTogglerText);
		if(this.loginButtonAnchor !== null && this.loginButtonAnchor !== "") {
			this.actions.appendChild(this.loginToggler);
		}
	}

	_addNarrowClasses () {
		const mainDiv = document.getElementById('main');
		const hasClassAsChild = mainDiv.querySelector('.c-hero-carousel') !== null;
		console.log(hasClassAsChild)
		for (let key in this.navigations) {
			if (this.navigations.hasOwnProperty(key)) {
				let navigation = this.navigations[key];
				if(navigation) {
					let firstClass = navigation.className.split(' ')[0];
					navigation.classList.add(`${firstClass}--narrow`);
					if (this.homePage && hasClassAsChild) {
						navigation.classList.add(`${firstClass}--narrow-home`);
					}
				}
			}
		}
	}

	_removeNarrowClasses () {
		for (let key in this.navigations) {
			if (this.navigations.hasOwnProperty(key)) {
				let navigation = this.navigations[key];
				if(navigation) {
					let firstClass = navigation.className.split(' ')[0];

					navigation.classList.remove(`${firstClass}--narrow`);
					navigation.classList.remove(`${firstClass}--narrow-home`);
				}
			}
		}
	}

	_createMenuDrawerToggler () {
		this.menuDrawerToggler = document.createElement('button');
		this.menuDrawerToggler.classList.add(this.settings.classes.drawerToggler);

		this.menuDrawerTogglerIcon = icon({
			icon: '/gui/images/icons/menu.svg',
			size: 's',
			extraClass: 'c-header__drawer-toggler-icon'
		});
		this.menuDrawerToggler.appendChild(this.menuDrawerTogglerIcon);

		this.menuDrawerTogglerText = document.createElement('span');
		this.menuDrawerTogglerText.innerHTML = 'Meny';
		this.menuDrawerToggler.appendChild(this.menuDrawerTogglerText);

		this.actions.appendChild(this.menuDrawerToggler);

		this.menuDrawerToggler.addEventListener('click', () => {
			if(this.searchDrawer && this.searchDrawer.isOpen()) {
				this.searchDrawer.close();
				this._updateDrawerToggler(this.searchDrawer, this.searchDrawerToggler, this.searchDrawerTogglerText, '/gui/images/icons/magnifying-glass.svg', 'Sök');
			}
			this.menuDrawer.toggle();
		});
	}

	_createSearchDrawerToggler () {
		if(this.searchDrawer) {
			this.searchDrawerToggler = document.createElement('button');
			this.searchDrawerToggler.classList.add(this.settings.classes.drawerToggler);

			this.searchDrawerTogglerIcon = icon({
				icon: '/gui/images/icons/magnifying-glass.svg',
				size: 's',
				extraClass: 'c-header__drawer-toggler-icon'
			});
			this.searchDrawerToggler.appendChild(this.searchDrawerTogglerIcon);

			this.searchDrawerTogglerText = document.createElement('span');
			this.searchDrawerTogglerText.innerHTML = 'Sök';
			this.searchDrawerToggler.appendChild(this.searchDrawerTogglerText);

			this.actions.appendChild(this.searchDrawerToggler);

			this.searchDrawerToggler.addEventListener('click', () => {
				if(this.menuDrawer.isOpen()) {
					this.menuDrawer.close();
					this._updateDrawerToggler(this.menuDrawer, this.menuDrawerToggler, this.menuDrawerTogglerText, '/gui/images/icons/menu.svg', 'Meny');
				}
				this.searchDrawer.toggle();
			});
		}
	}

	_createTranslateToggler () {
		if(this.additional) {
			this.translateToggler = new PopOut({
				popOut: this.additional.querySelector('.c-pop-out')
			});
		}
	}

	_updateDrawerToggler (drawer, toggleButton, toggleText, defaultIconUrl, defaultText) {
		let toggleIcon = toggleButton.querySelector('.c-icon');

		toggleIcon.remove();

		if (drawer.isOpen()) {
			toggleIcon = icon({
				icon: '/gui/images/icons/cross.svg',
				size: 's',
				extraClass: 'c-header__drawer-toggler-icon'
			});
			toggleText.innerHTML = 'Stäng';
		}
		else {
			toggleIcon = icon({
				icon: defaultIconUrl,
				size: 's',
				extraClass: 'c-header__drawer-toggler-icon'
			});
			toggleText.innerHTML = defaultText;
		}

		toggleButton.appendChild(toggleText);
		toggleButton.insertBefore(toggleIcon, toggleText);
	}

	_makeMainNavigationCollapsable () {
		this.navigations.main.collapsableNavigation = new CollapsableNavigation({
			debug: false,
			element: this.navigations.main,
			classNames: {
				toggle: 'c-main-navigation__toggle'
			},
			icons: {
				collapsed: '/gui/images/icons/plus.svg',
				expanded: '/gui/images/icons/minus.svg'
			}
		});
	}

	/* =============================================================================
	 * Public methods
	============================================================================= */

	initNarrow () {
		this.element.classList.add('c-header--slim');
		document.body.style.paddingTop = `${this.element.offsetHeight}px`;
		this.actions = document.createElement('div');
		this.actions.classList.add('c-header__actions');

		this._createMenuDrawer();
		this._createSearchDrawer();
		this._createLoginbutton();
		this.element.appendChild(this.actions);
		this._createSearchDrawerToggler();
		this._createMenuDrawerToggler();
		this._makeMainNavigationCollapsable();
	}

	destroyNarrow () {
		this.menuDrawer.close();
		this.element.classList.remove('c-header--slim');
		this.actions.remove();
		document.body.style.paddingTop = '0';

		if(this.additional) {
			this.translateClone.querySelector('.c-additional-navigation__translate').classList.add('c-pop-out');
			this.ceiling.querySelector('.c-header__ceiling-inner').appendChild(this.additional);
			this.test.forEach((element) => {
				element.remove();
				this.additional.querySelector('ul').prepend(element);
			});
			this._createTranslateToggler();
		}

		if(this.ceiling) {
			this.element.appendChild(this.ceiling);
		}
		this.element.appendChild(this.inner);
		this.element.appendChild(this.floor);
		if(this.navigations.searchForm) {
			this.floorInner.appendChild(this.navigations.searchForm);
		}
		this.inner.prepend(this.logotype);

		this.navigations.main.collapsableNavigation.destroy();

		this._removeNarrowClasses();

		this.menuDrawerToggler.remove();
		this.menuDrawer.element.remove();
		this.menuDrawer = null;

		if(this.searchDrawer) {
			this.searchDrawer.close();
			this.searchDrawerToggler.remove();
			this.searchDrawer.element.remove();
			this.searchDrawer = null;
		}
	}

}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-header').forEach((element) => {
		element.header = new Header({
			element: element
		});
	});
});

export default Header;


// WEBPACK FOOTER //
// ./components/header/c-header.js